import React, { useState } from 'react';
import {
    Grid,
    TextField,
    Typography,
    Button,
    IconButton,
    Divider,
    MenuItem,
    useTheme, Stack
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { tokens } from '../../../theme/theme';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';

const severityOptions = ['Minor', 'Major', 'Fatal'];

const EmployeeAccidentSection = ({ accidentDetails, setAccidentDetails }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const handleAccidentChange = (index, e) => {
        const { name, value } = e.target;
        const updated = [...accidentDetails];
        updated[index][name] = value;
        setAccidentDetails(updated);
    };

    const addAccident = () => {
        setAccidentDetails([
            ...accidentDetails,
            {
                accidentDate: '',
                accidentTime: '',
                location: '',
                description: '',
                cause: '',
                injuryType: '',
                severity: '',
                reportedBy: '',
                actionTaken: '',
                remarks: ''
            }
        ]);
    };

    const removeAccident = (index) => {
        const updated = [...accidentDetails];
        updated.splice(index, 1);
        setAccidentDetails(updated);
    };

    return (
        <>
            {accidentDetails.map((accident, index) => (
                <Grid container spacing={2} key={index} mt={1}>
                    <Grid item xs={12}>
                        <Typography variant="h6">Accident {index + 1}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} lg={5.25} xl={3.5}>
                        <TextField
                            name="accidentDate"
                            label="Accident Date"
                            type="date"
                            value={accident.accidentDate}
                            onChange={(e) => handleAccidentChange(index, e)}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            size="small"
                           
                        />
                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Stack spacing={2}>
                                <DatePicker
                                    label="Accident Date"
                                    value={accident.accidentDate}
                                    onChange={(newValue) => {
                                        const updated = [...accidentDetails];
                                        updated[index].accidentDate = newValue;
                                        setAccidentDetails(updated);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    color: 'text.primary',
                                                },
                                                '& .MuiSvgIcon-root': {
                                                    color: 'secondary.main', // this sets calendar icon color
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </Stack>
                        </LocalizationProvider> */}
                    </Grid>

                    <Grid item xs={12} sm={6} lg={5.25} xl={3.5}>
                        <TextField
                            name="accidentTime"
                            label="Accident Time"
                            type="time"
                            value={accident.accidentTime}
                            onChange={(e) => handleAccidentChange(index, e)}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            size="small"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={5.25} xl={3.5}>
                        <TextField
                            name="location"
                            label="Location"
                            value={accident.location}
                            onChange={(e) => handleAccidentChange(index, e)}
                            fullWidth
                            size="small"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={5.25} xl={3.5}>
                        <TextField
                            name="injuryType"
                            label="Injury Type"
                            value={accident.injuryType}
                            onChange={(e) => handleAccidentChange(index, e)}
                            fullWidth
                            size="small"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={5.25} xl={3.5}>
                        <TextField
                            name="reportedBy"
                            label="Reported By"
                            value={accident.reportedBy}
                            onChange={(e) => handleAccidentChange(index, e)}
                            fullWidth
                            size="small"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={5.25} xl={3.5}>
                        <TextField
                            select
                            name="severity"
                            label="Severity"
                            value={accident.severity}
                            onChange={(e) => handleAccidentChange(index, e)}
                            fullWidth
                            size="small"
                        >
                            {severityOptions.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} lg={10.5}  xl={10.5}>
                        <TextField
                            name="description"
                            label="Description"
                            value={accident.description}
                            onChange={(e) => handleAccidentChange(index, e)}
                            fullWidth
                            multiline
                            rows={2}
                            size="small"
                        />
                    </Grid>

                    <Grid item xs={12} lg={10.5} xl={10.5}>
                        <TextField
                            name="remarks"
                            label="Remarks"
                            value={accident.remarks}
                            onChange={(e) => handleAccidentChange(index, e)}
                            fullWidth
                            multiline
                            rows={2}
                            size="small"
                        />
                    </Grid>

                    {index > 0 && (
                        <Grid item xs={12}>
                            <IconButton onClick={() => removeAccident(index)} color="error">
                                <DeleteIcon />
                            </IconButton>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
            ))}

            <Button
                size="small"
                sx={{ mt: 2, textTransform: 'none' }}
                onClick={addAccident}
                variant="outlined"
                color='secondary'
                startIcon={<AddIcon />}
            >
                Add Accident
            </Button>
        </>
    );
};

export default EmployeeAccidentSection;
